export default __webpack_public_path__ + "static/media/Me.dcbed56f.jpg";